import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/components/Home.vue'
import OneStopService from '@/components/OneStopService.vue'
import PolicyInfo from '@/components/PolicyInfo.vue'
import TrademarkRegistration from '@/components/TrademarkRegistration.vue'
import ForeignTradeAgent from '@/components/ForeignTradeAgent.vue'
import OrderFinancing from '@/components/OrderFinancing.vue'
import ExclusiveService from '../components/ExclusiveService.vue'
import CreditInsurance from '../components/CreditInsurance.vue'
import CreditInvestigation from '../components/CreditInvestigation.vue'
import InternationalStorage from '../components/InternationalStorage.vue'
import ShipBooking from '../components/ShipBooking.vue'
import DocumentService from '../components/DocumentService.vue'
import TransportInsurance from '../components/TransportInsurance.vue'
import CrossBorderEcommerce from '../components/CrossBorderEcommerce.vue'
import ForeignExchange from '../components/ForeignExchange.vue'
import TaxRefund from '../components/TaxRefund.vue'
import IntellectualProperty from '../components/IntellectualProperty.vue'
import LegalConsultant from '../components/LegalConsultant.vue'
import RussianTrade from '../components/RussianTrade.vue'
import ActivityPublish from '../components/ActivityPublish.vue'
import SupplyDemand from '../components/SupplyDemand.vue'
import AgentService from '../components/AgentService.vue'
import CustomService from '../components/CustomService.vue'
import FinancialService from '../components/FinancialService.vue'
import LegalService from '../components/LegalService.vue'
import NuclearBusinessScope from '../components/NuclearBusinessScope.vue'
import ForeignExchangeAccount from '../components/ForeignExchangeAccount.vue'
import TaxRegistration from '../components/TaxRegistration.vue'
import ExhibitionInfo from '../components/ExhibitionInfo.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/one-stop-service',
    name: 'OneStopService',
    component: OneStopService
  },
  {
    path: '/policy-info',
    name: 'PolicyInfo',
    component: PolicyInfo
  },
  {
    path: '/trademark-registration',
    name: 'TrademarkRegistration',
    component: TrademarkRegistration
  },
  {
    path: '/foreign-trade-agent',
    name: 'ForeignTradeAgent',
    component: ForeignTradeAgent
  },
  {
    path: '/order-financing',
    name: 'OrderFinancing',
    component: OrderFinancing
  },
  {
    path: '/exclusive-service',
    name: 'ExclusiveService',
    component: ExclusiveService
  },
  {
    path: '/credit-insurance',
    name: 'CreditInsurance',
    component: CreditInsurance
  },
  {
    path: '/credit-investigation',
    name: 'CreditInvestigation',
    component: CreditInvestigation
  },
  {
    path: '/international-storage',
    name: 'InternationalStorage',
    component: InternationalStorage
  },
  {
    path: '/ship-booking',
    name: 'ShipBooking',
    component: ShipBooking
  },
  {
    path: '/document-service',
    name: 'DocumentService',
    component: DocumentService
  },
  {
    path: '/transport-insurance',
    name: 'TransportInsurance',
    component: TransportInsurance
  },
  {
    path: '/cross-border-ecommerce',
    name: 'CrossBorderEcommerce',
    component: CrossBorderEcommerce
  },
  {
    path: '/foreign-exchange',
    name: 'ForeignExchange',
    component: ForeignExchange
  },
  {
    path: '/russian-trade',
    name: 'RussianTrade',
    component: RussianTrade
  },
  {
    path: '/tax-refund',
    name: 'TaxRefund',
    component: TaxRefund
  },
  {
    path: '/intellectual-property',
    name: 'IntellectualProperty',
    component: IntellectualProperty
  },
  {
    path: '/legal-consultant',
    name: 'LegalConsultant',
    component: LegalConsultant
  },
  {
    path: '/activity-publish',
    name: 'ActivityPublish',
    component: ActivityPublish
  },
  {
    path: '/supply-demand',
    name: 'SupplyDemand',
    component: SupplyDemand
  },
  {
    path: '/agent-service',
    name: 'AgentService',
    component: AgentService
  },
  {
    path: '/custom-service',
    name: 'CustomService',
    component: CustomService
  },
  {
    path: '/financial-service',
    name: 'FinancialService',
    component: FinancialService
  },
  {
    path: '/legal-service',
    name: 'LegalService',
    component: LegalService
  },
  {
    path: '/nuclear-business-scope',
    name: 'NuclearBusinessScope',
    component: NuclearBusinessScope
  },
  {
    path: '/foreign-exchange-account',
    name: 'ForeignExchangeAccount',
    component: ForeignExchangeAccount
  },
  {
    path: '/tax-registration',
    name: 'TaxRegistration',
    component: TaxRegistration
  },
  {
    path: '/exhibition-info',
    name: 'ExhibitionInfo',
    component: ExhibitionInfo
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router